var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgProductHomemadeChoosing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 60,
    transform: "translate(1308 624)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-1308 -624)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1306 622)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39,43h2v2H39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37,45h2v2H37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39,47h2v2H39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22,30H42a1,1,0,0,0,1-1V22h1a3,3,0,0,0,3-3V15a3,3,0,0,0-3-3H43V3a1,1,0,0,0-1-1H22a1,1,0,0,0-1,1v9H20a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h1v7A1,1,0,0,0,22,30ZM43,14h1a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1H43ZM23,4H41V8H23Zm0,6H41V28H23ZM20,20a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h1v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25,12h2v2H25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37,12h2v2H37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31,15h2v6H31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,25a4.979,4.979,0,0,0-2-3.978V10A4,4,0,0,0,8,6H7A1,1,0,0,0,6,7V21.022A4.992,4.992,0,1,0,14,25ZM8,8a2,2,0,0,1,2,2v6H8ZM8,18h2v2H8ZM9,28a3,3,0,1,1,3-3,3,3,0,0,1-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25,23H39v2H25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,50h5a.983.983,0,0,0,.817-.455L16,46.3V52H13a1,1,0,0,0-1,1,5.009,5.009,0,0,0,4,4.9V61a1,1,0,0,0,1,1H47a1,1,0,0,0,1-1V57.9A5.009,5.009,0,0,0,52,53a1,1,0,0,0-1-1H48V46.3l2.183,3.242A.983.983,0,0,0,51,50h5a4,4,0,0,0,4-4V31a1,1,0,0,0-1-1H51a1,1,0,0,0-1,1v1.556A3.959,3.959,0,0,0,48,32H16a3.959,3.959,0,0,0-2,.556V31a1,1,0,0,0-1-1H5a1,1,0,0,0-1,1V46a4,4,0,0,0,4,4ZM52,32h6V46a2,2,0,0,1-2,2H52Zm-4,2a2,2,0,0,1,2,2v9.7l-2-3ZM46,60H18V58H46ZM37.469,34H46V52H42.274a7.989,7.989,0,0,0-8.846-13.153Zm4.163,15.813a6,6,0,0,1-9.552-.385A1,1,0,0,0,31.26,49H29V43h2.26a1,1,0,0,0,.82-.428,6,6,0,1,1,9.552,7.241ZM34.865,34,32,37.438,29.135,34ZM18,34h8.531l4.7,5.641a.984.984,0,0,0,.555.312A7.955,7.955,0,0,0,30.759,41H29a2,2,0,0,0-2,2H24.829a3,3,0,1,0-5.063,3,3,3,0,1,0,5.063,3H27a2,2,0,0,0,2,2h1.76a8.01,8.01,0,0,0,.974,1H18Zm4,11a1,1,0,1,1,1-1,1,1,0,0,0,1,1h3v2H24a1,1,0,0,0-1,1,1,1,0,1,1-1-1,1,1,0,0,0,0-2Zm27.829,9A3.006,3.006,0,0,1,47,56H17a3.006,3.006,0,0,1-2.829-2ZM14,36a2,2,0,0,1,2-2v8.7l-2,3ZM6,32h6V48H8a2,2,0,0,1-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60,25a4.979,4.979,0,0,0-2-3.978c0-.008,0-.014,0-.022V18h1a1,1,0,0,0,1-1V6H58v6H56V6H54v6H52V6H50V17a1,1,0,0,0,1,1h1v3.022A4.992,4.992,0,1,0,60,25Zm-8-9V14h6v2Zm4,2v2H54V18ZM55,28a3,3,0,1,1,3-3,3,3,0,0,1-3,3Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHomemadeChoosing);
export default __webpack_public_path__ + "static/media/product-homemade-choosing.58b97ea1937969328e10adaafb75c3c0.svg";
export { ForwardRef as ReactComponent };